export class User {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  emailAddress: string;
  userStatus: UserStatus;
  userType: UserType;
  userRoles: AppRole[];
  userRoleId: number[];
  //   userLocation: Location;
  userLocationId: number;
  userLocations: Location[];
  isLes: boolean;
  agencyCode: string;
}

export class UserRegistrationModel {
  id: number;
  userTypeId: number;
  locationId: number;
  roleIds: number[];
}

export interface PostLocationsModel {
  region: string;
  country: string;
  post: string;
  postId: number;
}

export interface HqLocationsModel {
  hq: string;
  programArea: string;
  division: string;
  divisionId: number;
}

export class UserStatus {
  id: number;
  statusName: string;
}

export class UserType {
  // constructor(Id:number, TypeName:string)
  // {
  //     this.id = Id;
  //     this.typeName=TypeName;
  // }
  id: number;
  typeName: string;
}

export class AppRole {
  id: number;
  roleName: string;
  // flagValue: number;      // 16 bit signed integer
}

export class Location {
  id: number;
  locationName: string;
  parentLocationId: number;
  parentLocationName:string;
  locationTypeId: number;
  locationId: number;
  parentId:number;  
  isActive:boolean;
  lastUpdatedBy:string;
  lastUpdatedDateTime :Date;
  parentLocation:Location;
}



export class PostUserType {
  constructor(Id: number, TypeName: string, Descripton: string) {
    this.id = Id;
    this.typeName = TypeName;
    this.description = Descripton;
  }
  id: number;
  typeName: string;
  description: string;
}

export class ReleaseNote {
  id: number;
  releaseTitle: string;
  releaseDetail: string;
  deploymentDate: Date;
  isActive: boolean;
  lastUpdatedDateTime: Date;

}


// WEBPACK FOOTER //
// ./src/app/models/user.model.ts